import React from 'react'

import {
  Body2,
  Box,
  Color,
  Display,
  Display1,
  FlexDirection,
  FontWeight,
  Heading6,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import type { LandingExperienceHero } from '@library/api-customer-engagement-experience'

import heroImage from '../assets/hero.webp'

const HeroHeadline = withCitrusTheme(Display1, () => ({
  fontWeight: 800,
  textTransform: 'uppercase',
  margin: 0,
}))

type HeroPanelProps = {
  hero: LandingExperienceHero
}

export const HeroPanel = ({ hero }: HeroPanelProps) => (
  <Box
    display={[Display.None, null, Display.Flex]}
    flexDirection={FlexDirection.Column}
    gap={2}
    justifyContent={JustifyContent.Center}
    paddingH={3}
    paddingV={4}
    flexShrink={0}
    width="340px"
    bg={Color.ColdGrey_800}
    style={{
      backgroundImage: `url(${heroImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}
  >
    <Heading6 size={1} color={Color.White} fontWeight={FontWeight.Bold}>
      {hero.welcome}
    </Heading6>
    <HeroHeadline color={Color.White} size={14}>
      {hero.headline}
    </HeroHeadline>
    <Body2 size={4} color={Color.White} style={{ whiteSpace: 'pre-line' }}>
      {hero.subtitle}
    </Body2>
  </Box>
)
